export function adminCompanyReducer(state = null, action) {
    switch (action.type) {
        case "LOGGED_IN_Admin":
            return action.payload;

        case "Admin_LOGOUT":
            return action.payload; //something like user will be nulled

        default:
            return state;
    }
}